import BeaconEventTransporter from './BeaconEventTransporter';
import HttpEventTransporter from './HttpEventTransporter';

export { BeaconEventTransporter };
export { HttpEventTransporter };

export default {
    BeaconEventTransporter,
    HttpEventTransporter,
};
